import { render, staticRenderFns } from "./default.vue?vue&type=template&id=52f9b20e&scoped=true"
import script from "./default.vue?vue&type=script&lang=ts"
export * from "./default.vue?vue&type=script&lang=ts"
import style0 from "./default.vue?vue&type=style&index=0&id=52f9b20e&prod&lang=less"
import style1 from "./default.vue?vue&type=style&index=1&id=52f9b20e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f9b20e",
  null
  
)

export default component.exports